



























import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class FreeTokensPage extends Vue {
  loading: boolean = true
  error: boolean = true

  getFreeTokens() {
    this.$http.get(`/api/free-tokens`)
      .then(response => {
        this.$user.tokensAmount += +response.data.amount
        this.$user.isDailyAvailable = false
        this.$eventBus.$emit('snackbar', { text: `Claimed ${response.data.amount} free daily coins` })
        // this.error = false
      })
      .catch(err => {
        this.$eventBus.$emit('snackbar', { text: `Already claimed, check back tomorrow` })
      })
      .finally(() => {
        // this.loading = false
      })
  }

  mounted() {
    document.title = 'Voize coins' + ' - ' + this.$appName
  }
}

